module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_function-to-string.js
// module id = 118
// module chunks = 0 1 2 3 4 5 6 7 8